// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";

import { isDimensionActionResultItem } from "../decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions/validators";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdError,
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult,
  PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult,
} from "./types";

const isNull = (v: unknown): v is null => v === null;

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult>({
    data: isDimensionActionResultItem,
  });

/** Narrows a failed read to the coded envelope. A routing 404 or a transport failure stays a plain FetchRequestError. */
export const isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdError = (
  error: FetchRequestError
): error is GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdError => {
  return error instanceof FetchUserEncodedError;
};

export const isPatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult =
  objectOf<PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult>({
    data: objectOf({
      action_id: number,
      replacement_action_id: anyOf(number, isNull),
    }),
    meta: isNull,
  });
